import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { EstimatesControllerCreateRoomBody } from "@rebuild/shared/generated/models/estimatesControllerCreateRoomBody";
import { ESTIMATE_KEYS } from "@/hooks/queries/estimates/queryKeys";

const { estimatesControllerCreateRoom } = getRebuildAPI();

export function useCreateRoomMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: EstimatesControllerCreateRoomBody) => {
      const response = await estimatesControllerCreateRoom(body);
      if (!response.success) {
        throw new Error("Failed to create room");
      }
      return response;
    },
    onSuccess: (_data, variables) => {
      if (variables.estimateId) {
        queryClient.invalidateQueries({ queryKey: ESTIMATE_KEYS.detail(variables.estimateId) });
      }
      toast.success("Room created");
    },
    onError: (error) => {
      toast.error("Failed to create room");
      console.error("Create room error:", error);
    },
  });
}
